function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { defineComponent, h } from '@vue/composition-api';
import EmptyBoxOutlined from '@kibt/meta-ui-icons/es/icons/EmptyBoxOutlined';
import Button from '../button';
import { withInstall } from '../util';
import "../style/components/empty.css";
var Empty = defineComponent({
  name: 'm-empty',
  props: {
    image: {
      type: [String, Object],
      "default": null
    },
    title: {
      type: String,
      "default": ''
    },
    desc: {
      type: String,
      "default": ''
    },
    buttonProps: {
      type: Object,
      "default": null
    },
    buttonText: {
      type: String,
      "default": ''
    },
    size: {
      type: String,
      "default": 'large'
    }
  },
  emits: ['click'],
  setup: function setup(props, context) {
    return function () {
      var image;

      if (props.image) {
        // image 作为图片url传递
        if (typeof props.image === 'string') {
          image = h("img", {
            "attrs": {
              "src": props.image
            }
          });
        } else {
          // image 作为jsx组件实例传递 :image="<Icon />"
          image = props.image;
        }
      } else if (context.slots.image && typeof context.slots.image === 'function') {
        // image 作为插槽传递
        image = context.slots.image();
      } else {
        // 图片的默认值
        image = h(EmptyBoxOutlined);
      }

      var btnProps = props.buttonProps || {};

      var buttonProps = _objectSpread(_objectSpread({}, btnProps), {}, {
        size: props.size === 'large' ? 'middle' : 'small'
      });

      return h("div", {
        "class": "m-empty m-empty-size-".concat(props.size)
      }, [h("div", {
        "class": "m-empty__image"
      }, [image]), props.title && h("div", {
        "class": "m-empty__title"
      }, [props.title]), props.desc && h("div", {
        "class": "m-empty__desc"
      }, [props.desc]), props.buttonText && h("div", {
        "class": "m-empty__btn"
      }, [h(Button, {
        "props": _objectSpread({}, buttonProps),
        "on": {
          "click": function click(e) {
            return context.emit('click', e);
          }
        }
      }, [props.buttonText])])]);
    };
  }
});
withInstall(Empty);
export default Empty;